export const GET_SHOPS = 'GET_SHOPS';
export const SUCCESS_GET_SHOPS = 'SUCCESS_GET_SHOPS';
export const FAIL_GET_SHOPS = 'FAIL_GET_SHOPS';

export const SET_DRAFT = 'SET_DRAFT';

export const CREATE_SHOP = 'CREATE_SHOP';
export const SUCCESS_CREATE_SHOP = 'SUCCESS_CREATE_SHOP';
export const FAIL_CREATE_SHOP = 'FAIL_CREATE_SHOP';

export const UPDATE_SHOP = 'UPDATE_SHOP';
export const SUCCESS_UPDATE_SHOP = 'SUCCESS_UPDATE_SHOP';
export const FAIL_UPDATE_SHOP = 'FAIL_UPDATE_SHOP';

export const UPDATE_SHOP_BAGS = 'UPDATE_SHOP_BAGS';
export const SUCCESS_UPDATE_SHOP_BAGS = 'SUCCESS_UPDATE_SHOP_BAGS';
export const FAIL_UPDATE_SHOP_BAGS = 'FAIL_UPDATE_SHOP_BAGS';

export const CREATE_SHOP_MENU = 'CREATE_SHOP_MENU';
export const SUCCESS_CREATE_SHOP_MENU = 'SUCCESS_CREATE_SHOP_MENU';
export const FAIL_CREATE_SHOP_MENU = 'FAIL_CREATE_SHOP_MENU';

export const EDIT_SHOP_MENU = 'EDIT_SHOP_MENU';
export const SUCCESS_EDIT_SHOP_MENU = 'SUCCESS_EDIT_SHOP_MENU';
export const FAIL_EDIT_SHOP_MENU = 'FAIL_EDIT_SHOP_MENU';

export const SET_DRAFT_MENU = 'SET_DRAFT_MENU';

export const GET_SHOP = 'GET_SHOP';
export const SUCCESS_GET_SHOP = 'SUCCESS_GET_SHOP';
export const FAIL_GET_SHOP = 'FAIL_GET_SHOP';

export const UPDATE_MAIL_SENDERS = 'UPDATE_MAIL_SENDERS';
export const SUCCESS_UPDATE_MAIL_SENDERS = 'SUCCESS_UPDATE_MAIL_SENDERS';
export const FAIL_UPDATE_MAIL_SENDERS = 'FAIL_UPDATE_MAIL_SENDERS';

export const INIT_SHOP = 'INIT_SHOP';
